export class AANAnnouncements {
	private minHeight = "190px";

	init(): void {
		const announcements: HTMLElement[] = Array.from(document.querySelectorAll(".announcement.see-more"));

		announcements.forEach(announcement => {
			const button = announcement.querySelector(".expand-button") as HTMLElement;

			button.addEventListener("click", () => this.slideToggle(announcement));
		});
	}

	private slideUp(target: HTMLElement, duration = 500) {
		const button = target.querySelector(".expand-button") as HTMLElement;

		button.innerText = "Read More";

		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + "ms";
		target.style.height = target.offsetHeight + "px";

		// Not sure why this is needed, but unless it is here this breaks for all browsers.
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.overflow = "hidden";
		target.style.height = this.minHeight;
		window.setTimeout(() => {
			target.style.removeProperty("height");
			target.style.removeProperty("overflow");
			target.style.removeProperty("transition-duration");
			target.style.removeProperty("transition-property");

			target.classList.remove("open");
		}, duration);
	};

	private slideDown(target: HTMLElement, duration = 500) {
		const button = target.querySelector(".expand-button") as HTMLElement;
		const computedStyles = getComputedStyle(target);

		button.innerText = "Show Less";

		const height = Array.from<HTMLElement>(target.children as any).map(x => x.offsetHeight).reduce((a, b) => a + b, 0)
			+ parseInt(computedStyles.paddingTop.replace("px", ""), 10)
			+ parseInt(computedStyles.marginTop.replace("px", ""), 10)
			+ parseInt(computedStyles.paddingBottom.replace("px", ""), 10)
			+ parseInt(computedStyles.marginBottom.replace("px", ""), 10);

		target.style.overflow = "hidden";
		target.style.height = this.minHeight;
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + "ms";
		target.style.height = height + "px";
		window.setTimeout(() => {
			target.classList.add("open");

			target.style.removeProperty("height");
			target.style.removeProperty("overflow");
			target.style.removeProperty("transition-duration");
			target.style.removeProperty("transition-property");
		}, duration);
	};

	private slideToggle(target: HTMLElement, duration = 500) {
		if (window.getComputedStyle(target).height === this.minHeight) {
			return this.slideDown(target, duration);
		} else {
			return this.slideUp(target, duration);
		}
	};
}


document.addEventListener("DOMContentLoaded", () => {
	const announcements = new AANAnnouncements();

	announcements.init();
});
